const initialState = ''
// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case 'PRODUCT_FILTER':
      return action.payload
    default:
      return state
  }
};
export const productFilter = state => state
